import React, {useState} from "react";
import styles from "../styles/components/SongManagerPanel.module.css";
import EditSongForm from "./EditSongForm";
import Styles from "../styles/pages/ServicePlanner.module.css";
import { load_fetch } from "../pr_utils";
import ChordsEditor from "../pages/ChordsEditor";
import {useNavigate} from "react-router-dom";

const isEnabled = (value) => String(value) === "1";

const SongManagerPanel = ({ songs, updateSongList, initialSongToEdit = null }) => {
    const navigate = useNavigate();
    const [view, setView] = useState(initialSongToEdit ? 'EDITING_SONG' : 'SHOW_SONG_LIST');
    const [selectedSong, setSelectedSong] = useState(initialSongToEdit);
    const [editingSong, setEditingSong] = useState(Boolean(initialSongToEdit));
    const [editingChords, setEditingChords] = useState(false);

    const saveEditedSong = (editedSongData) => {

        editedSongData.operation = "UPDATE_SONG";

        load_fetch("handlers/Service_Handler.php", editedSongData, (data) => {
            if(!data['ERROR'] && !data['error']) {
                // Update the song list in the parent page
                updateSongList(data['DATA']);

                const updatedSong = data['UPDATED_SONG'] ?? data['DATA']?.[editedSongData.song_id];

                // Update the song being edited in this component
                setSelectedSong(updatedSong ?? editedSongData);

                // Close the form
                cancelEditSong();
            }

        });
    }

    const sortedSongs = () => {
        return Object.values(songs).sort((a, b) => {
            if (a.type !== b.type) return a.type.localeCompare(b.type);
            const aHymn = a.hymn_number ?? Infinity;
            const bHymn = b.hymn_number ?? Infinity;
            if (aHymn !== bHymn) return aHymn - bHymn;
            return a.title.localeCompare(b.title);
        });
    }
    const handleSongClicked = (song) => {
        setSelectedSong(song);
        setView('VIEW_SONG_DETAILS');
        console.log(song);
    }
    const reshowSongList = () => {
        setSelectedSong(null);
        setView('SHOW_SONG_LIST');
    }
    const editSong = () => {
        if(!selectedSong) {
            return;
        }

        setView('EDITING_SONG');
        setEditingSong(true);
    }
    const cancelEditSong = () => {
        setView('VIEW_SONG_DETAILS');
        setEditingSong(false);
    }

    const editChords = () => {
        navigate("../chords_editor?song_id=" + selectedSong.song_id);
        //setEditingChords(true);
    }
    const cancelEditingChords = () => {
        setEditingChords(false);
    }
    const saveEditedChords = async () => {
        return;
    }

    return (
        <div className={styles.panel}>
            <h2>Song Manager</h2>


            {view === 'SHOW_SONG_LIST' ?
            <table className={styles.songTable}>
                <thead>
                <tr>
                    <th>Title</th>
                    <th>Type</th>
                    <th>CCLI</th>
                    <th>Songwriter(s)</th>
                    <th>Hymn #</th>
                    <th>Slideshow?</th>
                    <th>Chords?</th>
                    <th>Blacklisted?</th>
                </tr>
                </thead>
                <tbody>
                {sortedSongs().map(song => (
                    <tr
                        key={song.song_id}
                        onClick={() => handleSongClicked(song)}
                        className={isEnabled(song.is_blacklisted) ? styles.blacklistedRow : ""}
                    >
                        <td>{song.title}</td>
                        <td>{song.type}</td>
                        <td>{song.ccli_number || "—"}</td>
                        <td>{song.songwriter || "—"}</td>
                        <td>{song.hymn_number || "—"}</td>
                        <td>{isEnabled(song.has_slideshow) ? "Yes" : "No"}</td>
                        <td>{isEnabled(song.has_chords) ? "Yes" : "No"}</td>
                        <td>{isEnabled(song.is_blacklisted) ? "Yes" : "No"}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        : ''}

            {view === 'VIEW_SONG_DETAILS' && selectedSong && (
                <div className={styles.songDetails}>
                    <div className={Styles.buttonBar}>
                        <button className={styles.menuButton} onClick={reshowSongList}>Back to Song List</button>
                        <button className={styles.menuButton} onClick={editSong}>Edit Song</button>
                        <button className={styles.menuButton} onClick={editChords}>Edit Chords</button>
                    </div>
                    <h3>Selected Song</h3>
                    <dl>
                        <div className={styles.detailRow}>
                            <dt>Title:</dt>
                            <dd>{selectedSong.title}</dd>
                        </div>
                        <div className={styles.detailRow}>
                            <dt>Type:</dt>
                            <dd>{selectedSong.type}</dd>
                        </div>
                        <div className={styles.detailRow}>
                            <dt>CCLI Number:</dt>
                            <dd>{selectedSong.ccli_number || '—'}</dd>
                        </div>
                        <div className={styles.detailRow}>
                            <dt>Songwriter(s):</dt>
                            <dd>{selectedSong.songwriter || '—'}</dd>
                        </div>
                        <div className={styles.detailRow}>
                            <dt>Hymn #:</dt>
                            <dd>{selectedSong.hymn_number || '—'}</dd>
                        </div>
                        <div className={styles.detailRow}>
                            <dt>Slideshow?:</dt>
                            <dd>{isEnabled(selectedSong.has_slideshow) ? 'Yes' : 'No'}</dd>
                        </div>
                        <div className={styles.detailRow}>
                            <dt>Chords?:</dt>
                            <dd>{isEnabled(selectedSong.has_chords) ? 'Yes' : 'No'}</dd>
                        </div>
                        <div className={styles.detailRow}>
                            <dt>Blacklisted?:</dt>
                            <dd>{isEnabled(selectedSong.is_blacklisted) ? 'Yes' : 'No'}</dd>
                        </div>
                        {isEnabled(selectedSong.is_blacklisted) && (
                            <>
                                <div className={styles.detailRow}>
                                    <dt>Blacklist Reason:</dt>
                                    <dd>{selectedSong.blacklist_reason || '—'}</dd>
                                </div>
                                <div className={styles.detailRow}>
                                    <dt>Blacklisted At:</dt>
                                    <dd>{selectedSong.blacklisted_at || '—'}</dd>
                                </div>
                            </>
                        )}
                        <div className={styles.detailRow}>
                            <dt>Notes:</dt>
                            <dd>{selectedSong.notes || '—'}</dd>
                        </div>
                    </dl>
                </div>
            )}


            {editingSong && selectedSong && (
                <EditSongForm song={selectedSong} onCancel={cancelEditSong} onSave={saveEditedSong}/>
            )}

            {editingChords && selectedSong && (
                <ChordsEditor song={selectedSong} onCancel={cancelEditingChords} onSave={saveEditedChords} />
            )}

        </div>
    );
};

export default SongManagerPanel;
